import { Navigate } from "react-router-dom"

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("userToken") !== null
  const isAdmin = localStorage.getItem("isAdmin") === "true"

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // If user is admin, redirect to admin dashboard
  if (isAdmin) {
    return <Navigate to="/admin-dashboard" replace />
  }

  return element
}

export default ProtectedRoute;

